import React from 'react';

import { useSelector } from 'react-redux';
import ModalFooterButton from 'components/Modal/ModalFooterButton';
import { Handle } from 'components/SocialAccountInfo';
import { Step } from 'components/SteppedModal';
import SwitchAccountMessage from 'components/SwitchAccountMessage';
import { blueskyUsernameSelector } from 'redux/modules/social';

export interface UseSwitchAccountStepConfig {
  isAuthenticating?: boolean;
  onReauthenticate: () => void;
  onCancel?: () => void;
}

export default function useSwitchAccountStep({
  isAuthenticating,
  onReauthenticate,
  onCancel,
}: UseSwitchAccountStepConfig): Step {
  const username = useSelector(blueskyUsernameSelector);

  return {
    id: 'switch',
    title: 'switch account',
    component: (
      <SwitchAccountMessage username={<Handle username={username} />} />
    ),
    renderFooterButtons: () => [
      <ModalFooterButton key="cancel" onClick={onCancel}>
        cancel
      </ModalFooterButton>,
      <ModalFooterButton
        key="submit"
        theme="submit"
        disabled={isAuthenticating}
        onClick={onReauthenticate}
      >
        switch accounts
      </ModalFooterButton>,
    ],
  };
}
